module.exports = __webpack_public_path__ + "images/44e188747b20e6234a7a9a5f03f9ba9925f1bb71ccf7a0f40a11e026e59b6fd5.svg";